import { render, staticRenderFns } from "./CardRolesTable.vue?vue&type=template&id=f332b258&"
import script from "./CardRolesTable.vue?vue&type=script&lang=js&"
export * from "./CardRolesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports